import { OtherSettings } from '../../../domain/otherSettings';

type OtherSettingsChanges = {
    anyChanges: boolean;
    changes: Array<keyof OtherSettings>;
}

export const useOtherSettingsChanged = (otherSettings: OtherSettings, originalOtherSettings: OtherSettings): OtherSettingsChanges => {
    const checkStringField = (a: string, b: string, name: keyof OtherSettings): Array<keyof OtherSettings> => a !== b ? [name] : [];
    const checkNumberField = (a: number, b: number, name: keyof OtherSettings): Array<keyof OtherSettings> => a !== b ? [name] : [];

    const changes: Array<keyof OtherSettings> = [
        ...checkStringField(otherSettings.defaultCurrency, originalOtherSettings.defaultCurrency, 'defaultCurrency'),
        ...checkNumberField(otherSettings.startMonth, originalOtherSettings.startMonth, 'startMonth'),
        ...checkNumberField(otherSettings.startYear, originalOtherSettings.startYear, 'startYear'),
    ];

    return {
        anyChanges: changes.length > 0,
        changes
    };
};
